<template>
  <div class="admin-number-list px-2 px-md-4 py-2 py-md-4">
    <ConveyTable
      showSearch
      tableClassName="admin-number-table"
      :items="numbers"
      :fields="fields"
      :placeholders="placeholders"
      :perPageOptions="perPageOptions"
      :perPage="perPage"
      :currentPage="currentPage"
      :totalRows="totalRows"
      :isLoading="isFetchingNumbers"
      @onFetch="(options) => fetchNumbers(options)"
    >
      <template #cell(number)="data">
        <template v-if="!$permission('read:user')">
          {{ data.value }}
        </template>
        <router-link v-else :to="`/admin/numbers/${data.item.number_id}`">
          {{ data.value }}
        </router-link>
      </template>
      <template #cell(capabilities)="data">
        <span
          v-for="capability in data.value"
          :key="`${capability}_${data.item.number_id}`"
          class="bg-light-success text-success badge font-weight-medium mr-1"
        >
          {{ capability }}
        </span>
      </template>
    </ConveyTable>
  </div>
</template>

<script>
/* eslint-disable */
import formatter from "@/mixins/formatter";
import errorHandler from "@/mixins/errorHandler";
import ConveyTable from "@/components/ConveyTable";

export default {
  name: "AdminNumberList",
  mixins: [formatter, errorHandler],
  components: { ConveyTable },
  data() {
    return {
      numbers: [],
      query: "",
      perPage: 10,
      perPageOptions: [5, 10, 25, 50, 100],
      currentPage: 1,
      totalRows: 0,
      isFetchingNumbers: false,
      fields: [
        { key: "number", label: "Number", sortable: false },
        { key: "label", label: "Label", sortable: false },
        { key: "capabilities", label: "Capabilities", sortable: false },
        { key: "countryCode", label: "ISO Code", sortable: false },
        { key: "provider", label: "Provider", sortable: false },
        { key: "status", label: "Status", sortable: false },
        { key: "createdDate", label: "Created", sortable: false },
      ],
      placeholders: {
        search: "Search number..."
      },
      fetchAbortController: null,
    };
  },
  methods: {
    abortFetchOperation() {
      if (this.fetchAbortController) {
        this.fetchAbortController.abort();
        this.fetchAbortController = null;
      }
    },
    async fetchNumbers(fetchOptions) {
      try {
        this.abortFetchOperation();
        this.fetchAbortController = new AbortController();
        const {
          perPage,
          currentPage,
          searchKey
        } = fetchOptions;
        this.perPage = perPage;
        this.currentPage = currentPage;
        this.isFetchingNumbers = true;

        const offset = (currentPage - 1) * perPage;
        const params = {
          offset,
          limit: this.perPage,
        };
        if (searchKey) {
          let query = searchKey;
          let str = searchKey.replace(/[^0-9]/g, "");
          if (str.length == 10) {
            query = `+1${str}`;
          } else if (str.length == 11) {
            query = `+${str}`;
          }
          params['number'] = query;
        }

        const resp = await this.$ConveyApi.numbersApi.getProviderNumbers({
          params,
          signal: this.fetchAbortController.signal,
        });
        const { data, metadata } = resp.data;
        this.numbers = data.map((item) => {
          const { number, capabilities, created_at, status, country_code, provider } = item;
          return {
            ...item,
            number: this.prettyPhoneNumber(number),
            capabilities: this.capabilityTags(capabilities),
            createdDate: created_at ? this.formatDate(new Date(created_at).getTime(), "MMM DD, YYYY h:mm a") : "",
            countryCode: country_code ? country_code.toUpperCase() : "",
            status: status ? status.charAt(0).toUpperCase() + status.slice(1) : "",
            provider: provider ? provider.charAt(0).toUpperCase() + provider.slice(1) : ""
          };
        });
        this.totalRows = metadata ? metadata.totalRows || 0 : 0;
      } catch(err) {
        if (!this.isApiCanceled(err)) {
          console.log("[AdminNumberList:fetchNumbers] ERROR: ", err);
        }
      } finally {
        this.isFetchingNumbers = false;
      }
    },
    capabilityTags(tags) {
      return tags.split(",");
    },
  },
  beforeDestroy() {
    this.abortFetchOperation();
  }
};
</script>

<style lang="scss">
.admin-number-list {
  width: 100%;
  height: 100%;
}
</style>
